// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2451f43","455":"c2e3859f","578":"38775415","844":"217c6d6a","857":"91b67dbb"}[chunkId] + ".chunk.js";
};